<mat-toolbar>
  <span>Mes autorisations</span>
  <span class="spacer"></span>
  <app-filiale-selector></app-filiale-selector>
   <app-officine-selector type="gestion_authorisation"></app-officine-selector>
</mat-toolbar>

<nav class="sub-nav">
  <a
    routerLink="accord-extraction"
    routerLinkActive="active"
    class="sub-nav-link"
  >
    ACCORD D’EXTRACTION
  </a>
</nav>

<router-outlet></router-outlet>
